import Cookies from 'js-cookie'

jQuery(document).ready(function ($) {
    let blogURL = $('#logo').attr('href');
    let footerHeight = $('#footer').height();
    let winWidth = $(window).width();
    let clicked = false;
    let navID = $('#navigation');
    let closeFunc = false;

    // FAQ Accordion
    // $(function () {
    //     $("#accordion").accordion({
    //         collapsible: true,
    //         active: false,
    //         icons: { "header": "icon-plus", "activeHeader": "icon-minus" },
    //         heightStyle: 'content'
    //     });
    // });
    // Cookie Banner
    $(document).on('click', '#cookie-banner .btn', function (e) {
        e.preventDefault();
        $('#cookie-banner').removeClass('active');
        $('body').removeClass('cookie-banner-active');

        Cookies.set('cookie_seen', 1, { expires: 30 });
    });
    if (!Cookies.get('cookie_seen')) {
        $('#cookie-banner').addClass('active');
        $('body').addClass('cookie-banner-active');
    }
    // Res Menu
    $(document).on('click', '.body-overlay, .menu-close, .btn-close', function (e) {
        if (clicked) return;
        clicked = true;
        e.preventDefault();
        $('body').removeClass('overlay-active');
        $('body').removeClass('menu-active');
        $(this).removeClass('active');
        $('#menu-btn').removeClass('active');
        $('#active-modal').removeClass('active');

        setTimeout(() => {
            $('#active-modal').remove(); clicked = false;
        }, 300);
    });
    $(document).on('click', '#menu-btn', function (e) {
        if (clicked) return;
        clicked = true;
        e.preventDefault();

        var $this = $('.body-overlay');

        if ($(this).hasClass('active')) {
            // CLOSE 
            $('body').removeClass('overlay-active');
            $('body').removeClass('menu-active');
            $(this).removeClass('active');
            $this.removeClass('active');
        } else {
            // OPEN 
            $('body').addClass('overlay-active');
            $('body').addClass('menu-active');
            $(this).addClass('active');
            $this.addClass('active');
        }
        setTimeout(function () { clicked = false }, 300);
    });
    $(document).mouseup(function (e) {
        if ($('body').hasClass('overlay-active.menu-active')) {
            var menuCont = $("#res-menu-wrap");
            if (!menuCont.is(e.target) && menuCont.has(e.target).length === 0) {
                $('#menu-overlay').removeClass('active');
                $('#menu-btn').removeClass('active');
                $('body').removeClass('overlay-active');
                $('body').removeClass('menu-active');
            }
        }
        if ($('body').hasClass('overlay-active.modal-active')) {
            var weModal = $("#active-modal");
            if (!weModal.is(e.target) && weModal.has(e.target).length === 0) {
                weModal.removeClass('active');
            }
        }
    });
    // header hide
    let lastScrollTop = 0;
    let scrollChecker;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > 9) {
            // content shadow
            $('#content').addClass('scrolling')
        } else {
            $('#content').removeClass('scrolling')

        }
        let fixed_height = $('body').hasClass('single-product') || $('body').hasClass('home') ? 440 : 20;
        if (st > fixed_height) {
            $('#header, .quote-res-menu').addClass('fixed-header');
        } else {
            $('#header, .quote-res-menu').removeClass('fixed-header');
        }

        if (st > lastScrollTop) {
            if (scrollChecker != 'down') {
                $('#header, .quote-res-menu').removeClass('head-show');
                $('#header, .quote-res-menu').addClass('head-hide');
                scrollChecker = 'down';
            }
        } else {
            if (scrollChecker != 'up') {
                $('#header, .quote-res-menu').removeClass('head-hide');
                $('#header, .quote-res-menu').addClass('head-show');
                // headerAni.play();
                scrollChecker = 'up';
            }
            // upscroll code
        }
        lastScrollTop = st;
    });

    // pages
    let pageBanner = document.querySelector('#ob_banner')
    let pageBannerBg = document.querySelector('#ob_banner_bg')
    let page = document.querySelector('#page')

    if (pageBanner) {
        let h = pageBanner.offsetHeight

        if (pageBannerBg) pageBannerBg.style.height = `${h}px`
        page.style.paddingTop = `${h}px`

    }
});